module.exports = new __parcel__URL__("eazyBI.224ed97d.png").toString();